import axios from "axios";
import { toast } from "react-toastify";
import Auth from "../auth/Auth";

export function getCookie(cname) {
  if (!document.cookie.includes(cname)) return null; // Ensure cookie exists

  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let c of ca) {
    c = c.trim(); // Remove leading and trailing spaces
    if (c.startsWith(name)) {
      return c.substring(name.length);
    }
  }
  return null; // Return null instead of an empty string for better handling
}

// Add a request interceptor
// apiInstance.interceptors.request.use(
//   function (config) {
//     // Do something before request is sent
//     // config.headers = { ...getHeaders() };

//     return config;
//   },
//   function (error) {
//     // Do something with request error
//     toast.error(error.response.data.message);
//     return Promise.reject(error);
//   }
// );

// Add a response interceptor
// apiInstance.interceptors.response.use(
//   function (response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     // console.log("axios---------------",response);
//     // toast.success(response.data.message);
//     return {
//       data: response.data,
//       status: response.status,
//     };
//   },
//   function (error) {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error

//     if (error.response.status === 401) {
//       Auth.logout();
//       window.location.href = "/";
//     }
//     return Promise.reject(error);
//   }
// );


// Function to get headers with token
export const getHeaders = () => {
  const token = getCookie(Auth.tokenKey);

  if (!token) {
    console.warn("Warning: Token is missing or null. API call may fail.");
  }

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}), // Avoid adding an empty Authorization header
  };
};

const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: getHeaders(), // Ensure headers are included when the instance is created
});

// Interceptor to refresh headers dynamically in case token changes
apiInstance.interceptors.request.use((config) => {
  config.headers = getHeaders();
  return config;
}, (error) => Promise.reject(error));

export default apiInstance;


// export const headers = getHeaders();

export const uploadHeaders = {
  Accept: "multipart/form-data",
  "Content-Type": "multipart/form-data",
  Authorization: `Bearer ${Auth.token()}`,
};

